import { Controller } from "stimulus";

export default class AsyncBlockController extends Controller {

  static get targets() {
    return ["replace"];
  }

  static get values() {
    return {
      endpoint: String,
    };
  }

  // This is a simple controller to load a block of content when the page loads.
  // It should be used to give a quick initial response before calling out to an
  // an AJAX endpoint to do some expensive work.
  connect() {
    this.loadContent();
  }

  loadContent() {
    let el = this.hasReplaceTarget ? this.replaceTarget : this.element;
    fetch(this.endpointValue)
    .then((response) => response.text())
    .then((html) => {

      if (html.trim().length === 0) {
        let event = new CustomEvent("ajax:empty", {"detail": ""});
        el.dispatchEvent(event);
      } else {
        el.innerHTML = html;
      }

      // Trigger event to show block has loaded
      let event = new CustomEvent("ajax:success", {"detail": ""});
      el.dispatchEvent(event);
    })
    .catch(err => {
      el.replaceWith("Sorry, this content failed to load");

      let event = new CustomEvent("ajax:error", {"detail": ""});
      el.dispatchEvent(event);
    })
    .finally(() => {
      let event = new CustomEvent("ajax:complete", {"detail": ""});
      el.dispatchEvent(event);
    });
  }
}